import type { Theme } from "@mui/material/styles";
import { makeStyles, createStyles } from "@mui/styles";

export const FilterMobileStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      width: "auto",
      justifyContent: "center",
    },
    item: {
      height: "56px",
      alignSelf: "stretch",
      flexGrow: "0PC",
      display: "flex",
      flexDirection: "row",
      justifyContent: "flex-start",
      alignItems: "center",
      gap: "16px",
      padding: "12px",
      borderRadius: "10px",
      boxShadow: "none",
    },
    gridItem: {
      padding: "0",
    },
    title: {
      color: theme.palette.primary.main,
      fontSize: "16px",
      textAlign: "left",
      fontWeight: theme.typography.fontWeightBold,
      paddingBottom: "16px",
    },
    button: {
      marginTop: "5px",
      height: "48px",
      borderRadius: "6px",
      backgroundColor: theme.palette.secondary.main,
      textTransform: "none",
      transition: "background 0.5s, color 0.5s",
      "&:hover": {
        backgroundColor: theme.palette.primary.main,
        color: "#fff",
      },
    },
    buttonText: {
      fontSize: "16px",
    },
    buttonContainer: {
      height: "48px",
      marginBottom: "5px",
    },
    buttonClicked: {
      boxShadow: "inset 0 0 10px #000000",
    },
    buttonUnclicked: {
      boxShadow:
        "0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%)",
    },
  }),
);
